:host {
  display: block;
}

@media screen and (min-width: 980px) {
  :host {
    border-top: 1px solid #e7e6e6;
  }
}